import { MatchData } from '@/interfaces/liveGamesType';
import { GroupedMatches, TabsType, TabsValues } from '../types/index';

/**
 * Verifica se uma partida está ao vivo
 */
export const isMatchLive = (match: MatchData): boolean => {
  const status = match.match_status?.toLowerCase() || '';
  return status !== 'finished' && status !== 'ft' && match.match_live === '1'
};

/**
 * Filtra partidas com base em uma string de busca
 */
export const filterMatches = (
  matches: MatchData[], 
  searchQuery: string, 
  selectedLeagueId: string | null
): MatchData[] => {
  let filteredMatches = matches;
  
  // Filtrar por liga selecionada
  if (selectedLeagueId) {
    filteredMatches = filteredMatches.filter(match => match.league_id === selectedLeagueId);
  }
  
  // Filtrar por termo de busca
  if (searchQuery.trim()) {
    const query = searchQuery.toLowerCase();
    filteredMatches = filteredMatches.filter(match =>
      match.match_hometeam_name?.toLowerCase().includes(query) ||
      match.match_awayteam_name?.toLowerCase().includes(query) ||
      match.league_name?.toLowerCase().includes(query) ||
      match.country_name?.toLowerCase().includes(query)
    );
  }
  
  return filteredMatches;
};


/**
 * Obtém partidas de acordo com o tipo de aba selecionada
 */
export const getMatchesByTab = (
  tabValue: TabsType,
  liveMatches: MatchData[],
  finishedMatches: MatchData[],
  favorites: string[]
): MatchData[] => {
  const filteredFinishedMatches = finishedMatches.filter(match => !isMatchLive(match));
  switch (tabValue) {
    case TabsValues.ALL:
      return [...liveMatches, ...filteredFinishedMatches];
    case TabsValues.LIVE:
      return liveMatches;
    case TabsValues.FINISHED:
      return filteredFinishedMatches;
    case TabsValues.FAVORITES:
      return [...liveMatches, ...finishedMatches].filter(
        match => favorites.includes(match.match_id || '')
      );
    default:
      return [...liveMatches, ...finishedMatches];
  }
};

/**
 * Agrupa partidas por liga
 */
export const groupMatchesByLeague = (matches: MatchData[]): GroupedMatches => {
  const groupedMatches: GroupedMatches = {};

  matches.forEach(match => {
    const leagueId = match.league_id || '';
    const leagueName = match.league_name || '';
    const leagueLogo = match.league_logo || '';
    const country = match.country_name || '';

    if (!groupedMatches[leagueId]) {
      groupedMatches[leagueId] = {
        league: leagueName,
        leagueLogo: leagueLogo,
        country: country,
        matches: []
      };
    }

    groupedMatches[leagueId].matches.push(match);
  });

  return groupedMatches;
};
